import type { ILanguage, LanguageFragmentFragment } from "@/graphql";

type LanguageLike = Partial<ILanguage | LanguageFragmentFragment>;

export function languageKeyFromLocale(locale: string) {
  return locale.replace("-", "_") as keyof ILanguage;
}

export function createLanguageFromText(text: string, locale: string): ILanguage {
  return {
    [languageKeyFromLocale(locale)]: text,
  } as ILanguage;
}

export function getLocalizedLanguageValue(
  language: LanguageLike | null | undefined,
  locale: string,
) {
  const languageKey = languageKeyFromLocale(locale);
  return (
    language?.[languageKey] ||
    language?.en ||
    language?.en_GB ||
    language?.de ||
    Object.values(language ?? {}).find((value) => typeof value === "string" && value.length > 0) ||
    ""
  );
}

export function formatCodeName(item: any, locale: string, t?: (key: string) => string) {
  if (item == null) {
    return "";
  }
  const name =
    item.nameId != null && t != null
      ? t(`dynamic.${item.nameId}`)
      : getLocalizedLanguageValue(item.Name, locale);
  const fallbackName = name || item.name || "";
  return item.code != null && item.code !== "" ? `${item.code} - ${fallbackName}` : fallbackName;
}
